module.exports = __webpack_public_path__ + "Lato-Medium.e71ece21719025647a8a.woff2";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Medium.woff2
// module id = ../../../../../src/assets/fonts/Lato/Lato-Medium.woff2
// module chunks = styles